module.exports = __webpack_public_path__ + "static/media/rush_bookmark_night_2x.70e758be.jpg";